// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.turnstile-container {
  display: flex;
  justify-content: center;
  min-height: 65px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/turnstile/turnstile.component.scss"],"names":[],"mappings":"AAAA;EACC,cAAA;AACD;;AAEA;EACC,aAAA;EACA,uBAAA;EACA,gBAAA;AACD","sourcesContent":[":host {\n\tdisplay: block;\n}\n\n.turnstile-container {\n\tdisplay: flex;\n\tjustify-content: center;\n\tmin-height: 65px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
